<script lang="ts">
    export let tabs: Array<string>;
    export let activeTab: number;
</script>
<div class="mb-5">
    <div class="block">
        <div class="border-b border-gray-200">
            <nav class="-mb-px w-full flex" aria-label="Tabs">
                {#each tabs as tab, index}
                <div on:click={() => activeTab = index} class="{activeTab === index ? 'border-primary-500 text-primary-600': 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'} flex-1 border-b-2 py-4 px-1 text-center text-sm font-medium cursor-pointer">
                    {tab}
                </div>
                {/each}
            </nav>
        </div>
    </div>
</div>